<template>
  <article class="detail-item" :class="{ 'high-priority': data.star === 'high' }">
    <a-icon
      v-if="data.star === 'high'"
      type="star"
      theme="filled"
      class="priority-icon"
    />
    <span class="name"> {{ data.itemNo }}、{{ data.itemName }}</span>
    <span class="child">共{{ Math.floor(data.children) }}项</span>
    <span
      v-if="[Links.Rectification, Links.Examine, Links.End].includes(link) && data.status === 2"
      class="amend"
      >不符合{{ data.zgcount }}项</span
    >
    <span
      v-if="[Links.Rectification, Links.Examine, Links.End].includes(link) && data.status === 2"
      class="amendCom"
      >{{ data.zg }}</span
    >
  </article>
</template>
<script  setup>
  import { ITemplateData, Links } from '../data/template';
  import { useGetLink } from '../methods/getAddForm';
  import { ref } from 'vue';

  defineProps({
    data: {
      type: Object,
      default: () => ({}),
    },
  });
  const injectedLink = useGetLink();
  const link = injectedLink || ref(Links.End);
</script>
<style lang="less" scoped>
  .detail-item {
    width: 100%;
    font-size: 14px;
    line-height: 30px;
    border-bottom: 1px dashed #dcdcdc;
    margin-bottom: 15px;
    padding-bottom: 10px;
    cursor: pointer;
    padding-left: 20px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .name {
    font-size: 16px;
  }
  .amendCom {
    color: #67c23a;
  }
  
  /* 高优先级样式 */
  .high-priority {
    background: linear-gradient(90deg, #fff5f5 0%, #ffffff 100%);
    border-left: 3px solid #ff4d4f;
    font-weight: 500;
  }
  
  .priority-icon {
    color: #ff4d4f;
    font-size: 16px;
    margin-right: 4px;
  }
  .amend {
    color: #f56c6c;
  }
  .amendCom {
    color: #67c23a;
  }
</style>